import { AppState } from "../../store";

//Selectors that pull values from state.
export const selectAuthUser = (state: AppState) => state.reducer.Auth.authuser;
export const selectAppLoadComplete = (state: AppState) => state.reducer.Auth.appLoadComplete;
export const selectDataLoadComplete = (state: AppState) => state.reducer.Auth.dataLoadComplete; //cached lookups loaded flag.